module.exports = __webpack_public_path__ + "images/feature/GTD-2-a95cc934a266d8b2eff8b4a758f925de.jpg";